import {
  TOrderCheckoutItem,
  TOrderCheckoutItemProductType,
} from 'api/orders/orders.types';
import { TPhoneCaseBEItem } from 'api/phoneCases/phoneCases.types';
import { TStockItemBE } from 'api/stock/stock.types';

export function findStockLineByNameAndVariation(
  stocks: TStockItemBE[],
  name: string,
  variation: string
): TStockItemBE | undefined {
  const v = variation ?? '';
  return stocks.find((s) => s.name === name && (s.variation ?? '') === v);
}

export const buildCheckoutLine = (
  product: TPhoneCaseBEItem,
  stockItem: TStockItemBE,
  price: number,
  quantity: number
): TOrderCheckoutItem => ({
  productId: product.id,
  productType: TOrderCheckoutItemProductType.PhoneCase,
  productName: product.name,
  productImage: product.images[0] ?? '',
  price,
  quantity,
  stock: [
    {
      name: stockItem.name,
      variation: stockItem.variation ?? '',
    },
  ],
});
